import React from 'react';
import { legalContent } from "../legalContent";

export default function PrivacyPage() {
  const { title, body } = legalContent.privacy;

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.container}>
        {/* 🏠 Essential for Google Bot Navigation */}
        <a href="/" style={styles.backLink}>
          ← Back to Focused Trader Journal
        </a>

        <h1 style={styles.title}>
          {title}
        </h1>

        <div style={styles.contentBox}>
          {body.map((line, i) => (
            <p key={i} style={styles.paragraph}>
              {line}
            </p>
          ))}
        </div>
        
        <div style={styles.footer}>
          © {new Date().getFullYear()} Focused Trader Journal. Your data privacy is our priority.
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageWrapper: {
    background: "#000",
    minHeight: "100vh",
    width: "100%",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "60px 20px",
    color: "#94a3b8",
    fontFamily: "'Inter', sans-serif",
  },
  backLink: {
    color: "#38bdf8",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "600",
    display: "inline-block",
    marginBottom: "40px",
  },
  title: {
    color: "#f8fafc",
    marginBottom: "40px",
    fontSize: "32px",
    fontWeight: "800",
    letterSpacing: "-0.5px",
  },
  contentBox: {
    lineHeight: "1.8",
  },
  paragraph: {
    marginBottom: "20px",
    fontSize: "15px",
    color: "#94a3b8",
  },
  footer: {
    marginTop: "60px",
    paddingTop: "20px",
    borderTop: "1px solid #1e293b",
    fontSize: "12px",
    color: "#475569",
    textAlign: "center"
  }
};